// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SKdqZxOZ{align-items:center;display:flex;gap:1em;justify-content:center}.SKdqZxOZ i{font-size:1.3em}._6GKI-V\\+z{opacity:0}.dZ0pv8M9{filter:var(--filter-dimmed);pointer-events:none}.dZ0pv8M9 .SKdqZxOZ{opacity:0}.dZ0pv8M9 ._6GKI-V\\+z{font-size:1em;left:50%;opacity:1;position:absolute;top:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"content": "SKdqZxOZ",
	"spinner": "_6GKI-V+z",
	"btnLoading": "dZ0pv8M9"
};
module.exports = ___CSS_LOADER_EXPORT___;
